import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../constant/api';
import axios from 'axios';
import OfferImageBanner from '../../components/OfferImageBanner/OfferImageBanner';
import BannerProductCard from '../../components/BannerProductCard/BannerProductCard';
import SearchInput from '../../components/Home/SearchInput/SearchInput';
import { useParams } from 'react-router-dom';
import { GoHomeFill } from 'react-icons/go';

function Banner() {
    const [offerProducts, setOfferProducts] = useState([]);
    const [searchQuery, setSearchQuery] = useState(''); // Initialize searchQuery

    const { offerId } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/products/banners/${offerId}/`);
                console.log(response.data.Data);
                setOfferProducts(response.data.Data || []); 
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    // Handle search input changes
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };

    // Filter products based on search query
    const filteredProducts = offerProducts.filter((offer) => {
        return offer.name.toLowerCase().includes(searchQuery); 
    });

    // console.log(filteredProducts);

    return (
        <div>
            {/* Search Input */}
            <SearchInput
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder="Search product..."
                head="Banner"
                icon={<GoHomeFill />}
            />

            {/* Render Offers */}
            <OfferImageBanner offerId={offerId} />
            
            {offerProducts.length > 0 ? (
                filteredProducts.length > 0 ? (
                    filteredProducts.map((offer, index) => (
                        <div key={index} className="w-full">
                            {/* Offer Banner Image */}

                            {/* Offer Details */}
                            <div>
                                {/* <p>{offer.name}</p> */}
                                <BannerProductCard products={filteredProducts} />
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No products found matching your search.</p>
                )
            ) : (
                <div className="flex h-screen items-center justify-center space-x-2">
                    <div className="w-6 h-6 border-4 border-t-4 border-gray-500 rounded-full animate-spin"></div>
                    <p className="text-lg text-gray-600">Loading offers...</p>
                </div>
            )}
        </div>
    );
}

export default Banner;
